goog.provide("shadow.js.shim.module$$mui$material$Menu$default");
shadow.js.shim.module$$mui$material$Menu$default = shadow.js.shim.module$$mui$material$Menu.default;
